export const URL_FLAG_IS_CACHE_DISABLED =
  window.location.search.indexOf('cache=false') >= 0

export const URL_FLAG_FUTURE_MONTH_IS_ALLOWED =
  window.location.search.indexOf('futuremonths=true') >= 0

export const URL_FLAG_PERCEIVED_NOW =
  window.location.search.indexOf('now=') >= 0
